import ShipDashboard from '@/components/ships/dashboard/dashboard.vue';
import ShipForm from '@/components/ships/operations/operation_form.vue';
import ShipHealthReportForm from '@/components/ships/ship_health_report/ship_health_report_form.vue';
import ShipInspectionDetails from '@/components/ships/inspections/inspection_details.vue';
import ShipInspections from '@/components/ships/inspections/inspections.vue';
import ShipIssueForm from '@/components/issues/issue_form.vue';
import ShipIssueHistory from '@/components/issues/issue_history.vue';
import ShipIssueList from '@/components/ships/tasks/issue_list.vue';
import ShipLayout from '@/components/ships/ship_layout.vue';
import ShipManageRegions from '@/components/ships/operations/manage_regions.vue';
import ShipRegions from '@/components/ships/regions/regions.vue';
import ShipTaskList from '@/components/ships/tasks/task_list.vue';
import ShipTasks from '@/components/ships/tasks/tasks.vue';
import Configurations from '@/components/ships/configuration/configuration_page.vue';
import IssueLocationShip from '@/components/ships/location/issue_location_ship.vue';
import IssueLocationHme from '@/components/ships/location/issue_location_hme.vue';

import RegionsIssue from '@/components/regions/regions_issue_view.vue';
import RegionsIssueLocation from '@/components/ships/regions/regions_issue_location.vue';
import only from '../only';

export default [
  {
    path: 'ships/:shipId',
    component: ShipLayout,
    props: only('organisationId', 'shipId'),
    children: [
      {
        path: '',
        name: 'ship',
        component: ShipDashboard,
        props: true,
      },
      {
        path: 'regions/:issueType(ship)',
        name: 'shipRegions',
        component: ShipRegions,
        props: true,
        children: [
          {
            path: 'inspections/:inspectionId/issues/:issueId',
            name: 'shipRegionsIssue',
            component: RegionsIssue,
            props: true,
          },
          {
            path: 'inspections/:inspectionId/issues/:issueId/location/ship',
            name: 'shipIssuesLocationTypeShip',
            component: RegionsIssueLocation,
            props: true,
          },
        ],
      },
      {
        path: ':scope(inspections|approved_inspections)',
        name: 'shipInspections',
        component: ShipInspections,
        props: only('organisationId', 'shipId', 'scope'),
        children: [
          {
            path: ':inspectionId',
            name: 'shipInspection',
            component: ShipInspectionDetails,
            props: true,
          },
        ],
      },
      {
        path: 'tasks',
        component: ShipTasks,
        props: only('organisationId', 'shipId'),
        children: [
          {
            path: '',
            name: 'shipTasks',
            redirect: {
              name: 'shipTasksCategory',
              params: { category: 'all' },
            },
          },
          {
            path: ':category(all|current|past_due|completed)',
            name: 'shipTasksCategory',
            component: ShipTaskList,
            props: true,
          },
          {
            path: ':category(issues_missing_tasks|resolved_issues)',
            name: 'shipTaskIssuesCategory',
            component: ShipIssueList,
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: 'ships/:shipId/inspections/:inspectionId/issues/new',
    name: 'newShipIssue',
    component: ShipIssueForm,
    props: true,
  },
  {
    path: 'ships/:shipId/inspections/:inspectionId/issues/:issueId',
    name: 'shipIssue',
    component: ShipIssueForm,
    props: true,
  },
  {
    path: 'ships/:shipId/ship_health_reports/new',
    name: 'newShipHealthReport',
    component: ShipHealthReportForm,
    props: true,
  },
  {
    path: 'ships/:shipId/ship_health_reports/:shipHealthReportId/edit',
    name: 'editShipHealthReport',
    component: ShipHealthReportForm,
    props: true,
  },
  {
    path: 'ships/:shipId/inspections/:inspectionId/issues/:issueId/history',
    name: 'shipIssueHistory',
    component: ShipIssueHistory,
    props: true,
  },
  {
    path: 'ships/:shipId/regions/edit',
    name: 'shipManageRegions',
    component: ShipManageRegions,
    props: true,
  },
  {
    path: 'ships/:shipId/edit',
    name: 'editShip',
    component: ShipForm,
    props: true,
  },
  {
    path: 'ships/new',
    name: 'newShip',
    component: ShipForm,
    props: true,
  },
  {
    path: 'ships/:shipId/configuration',
    name: 'shipConfiguration',
    component: Configurations,
    props: true,
    children: [
      {
        path: 'ship',
        name: 'shipConfigurationShips',
        component: Configurations,
        props: true,
      },
      {
        path: 'heavy_mobile_equipment',
        name: 'shipConfigurationsHme',
        component: Configurations,
        props: true,
      },
    ],
  },
  {
    path: 'ships/:shipId/inspections/:inspectionId/issues/new/location/ship',
    name: 'shipNewIssueLocationShip',
    component: IssueLocationShip,
    props: true,
  },
  {
    path: 'ships/:shipId/inspections/:inspectionId/issues/:issueId/location/ship',
    name: 'shipIssueLocationShip',
    component: IssueLocationShip,
    props: true,
  },
  {
    path: 'ships/:shipId/inspections/:inspectionId/issues/new/location/heavy_mobile_equipment',
    name: 'shipNewIssueLocationHmes',
    component: IssueLocationHme,
    props: true,
    children: [
      {
        path: ':heavyMobileEquipmentId',
        name: 'shipIssueLocationHme',
        component: IssueLocationHme,
        props: true,
      },
    ],
  },
  {
    path: 'ships/:shipId/inspections/:inspectionId/issues/:issueId/location/heavy_mobile_equipment',
    name: 'shipIssueLocationHmes',
    component: IssueLocationHme,
    props: true,
    children: [
      {
        path: ':heavyMobileEquipmentId',
        name: 'shipIssueLocationHme',
        component: IssueLocationHme,
        props: true,
      },
    ],
  },
];
